import React, { useEffect, useState } from "react";
import { Modal, Button, Alert, Spinner, Table } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

export default function DetaliiScazutModal({ show, onHide, docId }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const idNum = Number(docId);
    if (!show || !idNum) return;

    let cancelled = false;

    (async () => {
      setBusy(true);
      setErr("");
      try {
        const data = await authFetch(`/iesire/${idNum}/stocout`);
        const items = Array.isArray(data)
          ? data
          : data?.items || data?.linii_out || [];
        if (!cancelled) setRows(items);
      } catch (e) {
        if (!cancelled) setErr(String(e?.message || e));
      } finally {
        if (!cancelled) setBusy(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [show, docId]);

  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Detalii scădere stoc (FIFO)</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {err && <Alert variant="danger">{err}</Alert>}

        {busy ? (
          <div className="d-flex align-items-center gap-2">
            <Spinner size="sm" />
            <span>Se încarcă…</span>
          </div>
        ) : (
          <Table bordered size="sm" className="align-middle">
            <thead>
              <tr>
                <th style={{ width: 90 }}>Linie</th>
                <th style={{ width: 140 }}>StocIn ID</th>
                <th>Produs</th>
                <th style={{ width: 120 }} className="text-end">
                  Qty scăzut
                </th>
                <th style={{ width: 160 }}>Intrare / Data</th>
                <th style={{ width: 220 }}>Pret intrare</th>
              </tr>
            </thead>
            <tbody>
              {rows?.length ? (
                rows.map((r, idx) => (
                  <tr key={r.id || idx}>
                    <td>{r.bxline_no ?? r.line_no ?? idx + 1}</td>
                    <td>{r.bxstocin_id ?? r.stocin_id ?? ""}</td>
                    <td>
                      <div className="fw-semibold">
                        {r.cod || r.part_cod || ""}
                      </div>
                      <div className="text-muted" style={{ fontSize: 12 }}>
                        {r.denumire || r.part_denumire || ""}
                      </div>
                    </td>
                    <td className="text-end">
                      {r.bxqtyscazut ?? r.qty ?? r.qty_scazut ?? ""}
                    </td>
                    <td>
                      {r.in_doc_no || r.doc_no || ""}{" "}
                      <span className="text-muted">
                        {r.in_doc_date || r.doc_date || ""}
                      </span>
                    </td>
                    <td>
                      <div className="text-muted">{r.pret_stocin}</div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-muted">
                    Nu există detalii de stocout (încă) pentru acest bon.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}

        <Alert variant="secondary" className="mt-3 mb-0 py-2">
          Aici vezi exact <b>din ce intrări (stocin)</b> s-a scăzut și în ce
          cantități (FIFO). Acestea sunt “adevărul” mișcării de stoc.
        </Alert>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
